import { TextField } from '@mui/material';
import { useSimpleSearchTheme } from '@/shared/ui/search/SimpleSearch/theme/useSimpleSearchTheme';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  onEnter?: () => void;
  placeholder?: string;
}

export function SearchInput({
  value,
  onChange,
  onEnter,
  placeholder = '검색어를 입력하세요',
}: SearchInputProps) {
  const { inputSx } = useSimpleSearchTheme();

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && onEnter) {
      onEnter();
    }
  };

  return (
    <TextField
      size="small"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={handleKeyDown}
      placeholder={placeholder}
      sx={inputSx}
      fullWidth
    />
  );
}
